import { render, staticRenderFns } from "./Comm.vue?vue&type=template&id=32ec36e4&scoped=true&"
import script from "./Comm.vue?vue&type=script&lang=js&"
export * from "./Comm.vue?vue&type=script&lang=js&"
import style0 from "./Comm.vue?vue&type=style&index=0&id=32ec36e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec36e4",
  null
  
)

export default component.exports